'use strict';
const Ids = {
    GET_FORM_VIEW_JSON: 'get/',
    GET_FOLDER_META_DATA: 'metadata/folderMetadata',
    GET_FORM_VIEW_JSON_BY_FORM_TYPE: 'metadata/edit/',
    SAVE_DESIGN: 'save',
    SAVE_DESIGN_BY_FORM_TYPE: 'metadata/saveDesign',
    DISCARD_DRAFT: 'metadata/discardDraft/',
    SEARCH_TEMPLATE: 'find',
    CREATE_TEMPLATE: 'save',
    DELETE_TEMPLATE: 'delete',
    GET_LANGUAGE_KEYS: 'language/messages/getall',
    GET_USP: 'user/usp/get',
    GET_AVAILABLE_SECONDARY_DS: 'getAvailableSecondaryDS',
    GET_APPS_LOOKUP_DATA: 'appsLookUpData',
    GET_ALL_LANGUAGES: 'languages/getall',
    UPDATE_TEMPLATENAME: 'metadata/updateTemplateName',
    GET_PROTECTED_PARAMS: 'reservedfields',
    ACTIVATE_USER_SESSION: 'login/activateUserSession',
    GET_SESSION_TIMEOUT_DETAILS: 'login/getSessionTimeoutDetails',
    GET_CUSTOM_ATTR_NAMES: 'form/canames',
    GET_NUMBER_FORMAT_ENABLED_DETAIL: 'home?action_id=1903',
    GET_ALL_FORMS: 'getAllAsiteSupportedApi',
    SAVE_API_CONNECTION: 'saveApiConnection',
    GET_API_CONNECTION_LIST: 'getApiConnectionList',
    COPY_API_CONNECTION: 'copyApiConnection',
    REMOVE_API_CONNECTION: 'deleteApiConnection',
    GET_ALL_PROJECTS: 'getPopupData',
    GET_FORMSTATUS_BY_PROJECTS: 'htmlForm/getStatusByProjectIds',
    GET_FORMSTYPEBYPROJECTS: 'htmlForm/getFormTypeDetailsByProjectIds',
    GET_CUSTOMFORMFIELDS: 'htmlForm/getCustomFormFieldsWithFormTypeIds',
    DESIGN_STYLE:{
        STANDARD: '1',
        ADVANCED: '2',
    }
};

export {
    Ids
}


// WEBPACK FOOTER //
// ./client/components/constants/action.constants.ts